import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  position: relative;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);

  &.scale-small {
    height: 300px;

    @media (min-width: 768px) {
      height: 400px;
    }

    @media (min-width: 992px) {
      height: 500px;
    }
  }

  &.scale-medium {
    height: 400px;

    @media (min-width: 768px) {
      height: 500px;
    }

    @media (min-width: 992px) {
      height: 600px;
    }
  }

  &.scale-large {
    height: 500px;

    @media (min-width: 768px) {
      height: 650px;
    }

    @media (min-width: 992px) {
      height: 800px;
    }
  }

  .carousel-swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const SlideContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    width: 100%;
    height: 100%;
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  @media (min-width: 768px) {
    bottom: 2rem;
    gap: 1rem;
  }

  @media (min-width: 992px) {
    bottom: 2.5rem;
    gap: 1.5rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    gap: 1rem;
  }

  color: #fff;
`;
